import * as actionTypes from './actionTypes';
import * as moduleActions from '../../Application/Components/Modules/moduleActions';
import * as notificationTypes from '../../Application/Components/Modules/Notification/notificationActions';
import * as taskTypes from '../../Application/Components/Modules/Task/taskActions';
import axios from '../../Axios/axios';
import HmacSHA256 from 'crypto-js/hmac-sha256';
import UTF8 from 'crypto-js/enc-utf8';
import Base64 from 'crypto-js/enc-base64';

//const FileDownload = require('js-file-download');

var SecurityManager = {
    salt: 'x6aOEWzbq6GWTFNdbyuo',
    username: localStorage.getItem('SecurityManager.username'),
    key: localStorage.getItem('SecurityManager.key'),
    ip: null,
    CreateUID: function () {

        var dt = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
        });
        return uuid;
    },
    generate: function (username, password) {

        var uuid = this.CreateUID();
        // Set the username.
        SecurityManager.username = username; // SecurityManager.username || username;

        // Set the key to a hash of the user's password + salt.
        SecurityManager.key = Base64.stringify(HmacSHA256([password, SecurityManager.salt].join(':'), SecurityManager.salt));//SecurityManager.key || Base64.stringify(HmacSHA256([password, SecurityManager.salt].join(':'), SecurityManager.salt));

        // Set the client IP address.
        SecurityManager.ip = "192.168.56.1";

        // Persist key pieces.
        if (SecurityManager.username) {
            localStorage.setItem('SecurityManager.username',SecurityManager.username);
            localStorage.setItem('SecurityManager.key',SecurityManager.key);
        }

        // Get the (C# compatible) ticks to use as a timestamp. http://stackoverflow.com/a/7968483/2596404
        var ticks = ((new Date().getTime() * 10000) + 621355968000000000);

        // Construct the hash body by concatenating the username, ip, and userAgent.
        var message = [SecurityManager.username, SecurityManager.ip, navigator.userAgent.replace(/ \.NET.+;/, ''), ticks].join(':');
        message = [SecurityManager.username, "192.168.56.1", uuid, ticks].join(':');
        
        // Hash the body, using the key.
        var hash = HmacSHA256(message, SecurityManager.key);

        // Base64-encode the hash to get the resulting token.
        var token = Base64.stringify(hash);

        // var token = CryptoJS.enc.Base64.stringify(hash); ===== hashLeft = Convert.ToBase64String(hmac.Hash);
        // Include the username and timestamp on the end of the token, so the server can validate.
        // var tokenId = [SecurityManager.username, ticks].join(':');
        var tokenId = [SecurityManager.username, "192.168.56.1", uuid, ticks].join(':');

        // Base64-encode the final resulting token.
        var tokenStr = UTF8.parse([token, tokenId].join(':'));
        var tokenfinal = Base64.stringify(tokenStr);

        //----
        // Voici la chaîne attendue :) :):) :):):):):):):):)::):):):):
        //----
        // dXoxZDJwSTBTL3R4dUZXVDhDV21aT1RKMDJ6a280MVZCeVpBMmFma0Q3ST06UFZTOjE5Mi4xNjguNTYuMTpkOTBiMjViZi0wNTFlLTQ3MzAtYjY4Yy02NmY2NzMwMDk5NmY6NjM3MTk0MzMwNTA2MTU2MTU3

        return tokenfinal;

    },
};

var transfertObject = {
    FLAG:0,
    ObjDataDto:null,
    ObjDatasCibleDto:null,
    ObjDatasSourceDto:null,
    ObjParamDto:null,
    ObjParamsDto:null,
    Session:{
        Application:"REASSURANCE",
        CodeApplication:4,
        Session:null
    },
    objFile:null,
    vntIndexKey:0
};
var ObjParamsDto={
    ARCS_PER:0,
    ARCS_TP_N3:0,
    CD:"",
    DestroyCol:0,
    LNH:'L',
    RecordFlag:'ALL',
    SV:0,
    SessionIDE:"",
    ToIUD:0,
    sPageFilter:"",
    bPageIsActive:true,
    iPageNumber:0,
    iPageWeigth:40,
    iPageSort:"",
}
var ObjParamDto={
    ARCS:0,
    CODE:'',
    Locked:0,
    ETAT:0,
    SV:0,
    CD:'',
    LNH:'L',
    RecordFlag:'ALL',
    SessionIDE:"",
    sPageFilter:"",
    bPageIsActive:true,
    iPageNumber:0,
    iPageWeigth:40,
    iPageSort:"",    
}

// INIT APP
export const checkServerStatus = (props) => {
    var geoLat = 0;
    var geoLong = 0;
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(successFunction, errorFunction);
    } else {
        moduleActions.addModuleData("NOTIFICATION",
            {
                type:"exclamation-triangle",
                title:"No GeoLocalisation",
                description : "Browser do not support geolocalisation or user do not allow geolocalisation usage"
            }
        )
    }

    
    //var UID = localStorage.getItem('Reassurance.session.sessionId') != null ? localStorage.getItem('Reassurance.session.sessionId') : CreateUID();
    
    var sessionReact = {
        Application: 'Reassurance',
        CodeApplication: 4,
        Session: {
            SEQ: 0,
            VER_MAJOR: 1,
            VER_MINOR: 0,
            VER_PATCH: 0,
            EMP_ARCS: 0,
            EMP_IDE: '',
            EMP_USER: '',
            EMP_MDP: '',
            EMP_ENTREPRISE: 0,
            EMP_LAN: 'FR',
            LOC_IP: '0.0.0.0',
            LOC_LATITUDE: geoLat,
            LOC_LONGITUDE: geoLong,
            LOC_ACCURACY: 0,
            SESSION_TYPE: 4,
            SESSION_TOKEN: "",
            SESSION_ID: "",
            SESSION_START: Math.round(new Date().getTime()),
            SESSION_END: -62135596800000,
            NAV_CODE_NAME: navigator.appCodeName,
            NAV_NAME: navigator.appName,
            NAV_VERSION: navigator.appVersion,
            NAV_COOKIE: 1,
            NAV_LANGUAGE: navigator.language,
            NAV_ONLINE: navigator.onLine,
            NAV_PLATFORM: navigator.platform,
            NAV_PRODUCT: navigator.product,
            NAV_USER_AGENT: navigator.userAgent,
            NAV_JAVA_ENABLED: 1,
            SCREEN_AVAIL_HEIGTH: window.screen.availHeight,
            SCREEN_AVAIL_WIDTH: window.screen.availWidth,
            SCREEN_COLOR_DEPTH: window.screen.colorDepth,
            SCREEN_HEIGTH: window.screen.height,
            SCREEN_WIDTH: window.screen.width,
            SCREEN_PIXEL_DEPTH: window.screen.colorDepth,
            NSYS: 4,
          }
        
    };
   

    return (dispatch) => {
        axios.ArcsAxios.post("WCFWindowsArcs/ARCSCheck", 4)
            .then(response => {
                dispatch(checkServerStatusReturn(response, sessionReact));
                
            })
            .catch(error => {
                console.log("Error");
                console.log(error);
            })
    }
};

const checkServerStatusReturn = (response, sessionReact) => {
    return {
        type: actionTypes.OPEN_SESSION_RETURN,
        data: { sessionReact: sessionReact, response: response }
    }
}
const successFunction = (position) =>{
        var lat = position.coords.latitude;
        var long = position.coords.longitude;
}
const errorFunction = (position) =>{
    console.log('Error getting position');
}

export const toggleConnect = () => {

    return {
        type: actionTypes.TOGGLE_CONNECT,
        data: {}
    }
};

// export const autoLoginTry = (session,user)=>{
//     var userTmp = {arcs:user.ARCS,fullName:user.USER,login:user.IDE,sessionId:session.Session.SESSION_ID};
//     var success = false;
//     console.log("AUTO LOGIN");
//     return (dispatch) => {
//         // USER LOGIN
//         var Session = transfertObject.Session;
//         Session = session;
//         axios.ArcsAxios.post("WCFWindowsArcs/EmpGetUserByLoginAndPasswordSECURE",Session)
//         .then(sessionOpen => {
            
//             console.log("Success");
//             dispatch(logUser(userTmp));
//             dispatch(toggleConnect());
//             dispatch(updateSession(Session));
//             success = true;
//         }).catch(error => {
//             dispatch(loginReturn(false));
            
//         }).finally(res=>{
//             if(success){
//                 dispatch(get_TDI(Session.Session.Session));
//             }
//         });
        
       

//     }

// }
export const disconnect = () => {

    return {
        type: actionTypes.DISCONNECT,
        data: {}
    }
};

export const loginTry = (obj) => {
    return (dispatch) => {
        var token = "";
        var tmpPassword = "";
        var tmpUserName = "";
        var tmpDomain = "";

        tmpPassword = obj.ObjParamDto.MDP;
        tmpUserName = obj.ObjParamDto.IDE;
        tmpDomain = obj.ObjParamDto.SIG;
        token = SecurityManager.generate(tmpUserName, tmpPassword);
        //DO NOT SHOW PASSWORD
        obj.ObjParamDto.MDP = "";

        obj.ObjParamDto.SessionIDE = token;
        obj.Session.Session.SESSION_ID = token;
        obj.Session.Session.SESSION_TOKEN = token;
        obj.Session.Session.EMP_IDE = tmpUserName;
        obj.Session.CodeApplication = tmpDomain;
        var objTmp = obj;
        axios.ArcsAxios.post("WCFWindowsArcs/EmpGetUserByLoginAndPasswordSECURE", obj.Session)
            .then(response => {
                
                if (response.data.USER !== "") {
                    
                    localStorage.setItem('Reassurance.session.arcs',response.data.ARCS);
                    localStorage.setItem('Reassurance.session.fullname',response.data.USER);
                    localStorage.setItem('Reassurance.session.login',response.data.IDE);
                    localStorage.setItem('Reassurance.session.sessionId',token);
                    localStorage.setItem('Reassurance.session.session',JSON.stringify(objTmp.Session));
                    localStorage.setItem('Reassurance.session.user',JSON.stringify(response.data));
                    
                    var user = {arcs:response.data.ARCS,fullName:response.data.USER,login:response.data.IDE,sessionId:token};

                    dispatch(logUser(user));
                    dispatch(toggleConnect());
                    dispatch(updateSession(obj.Session));
                    
                    // GET TDI
                    // TODO

                    axios.ReassAxios.post("WCFWindowsReassurance/ReassuranceOpen", obj)
                        .then(sessionOpen => {
                            dispatch(get_TDI(obj.Session.Session));
                            console.log("GET TASK");
                            dispatch(taskTypes.getTask(obj));
                        }).catch(error => {
                            dispatch(loginReturn(false));
                            
                        })

                } else {
                    dispatch(loginReturn(false));
                    dispatch(notificationTypes.addNotification("info-circle","Invalid Credential","The server did not return a valid user matching this credential. Please double check the information you have entered"))
                    
                }

            })
            .catch(error => {
                dispatch(loginReturn(false));
                
            })
    }
};
export const updateSession = (session) =>{
    return {
        type: actionTypes.UPDATE_SESSION,
        data: session
    }
}

export const loginReturn = (data) => {
    return {
        type: actionTypes.LOGIN_RETURN,
        data: data
    }
}
export const logUser = (user)=>{
    
    return {
        type: actionTypes.LOG_USER,
        data: user
    }
}


export const initAppStructure = (content) =>{
    return {
        type: actionTypes.UPDATE_APP_STRUCTURE,
        data: content
    }
}

export const loadClients = (content) =>{
    return {
        type: actionTypes.UPDATE_CLIENTS_LIST,
        data: content
    }
}


// APP METHODS
const stopLoading = () => {
    return {
        type: actionTypes.STOP_LOADING,
        data: null
    }
}

const startLoading = () => {
    
    return {
        type: actionTypes.START_LOADING,
        data: null
    }
}


export const CreateUID =()=>{
   
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c==='x' ? r :((r&0x3)|0x8)).toString(16);
    });
    return uuid;
}




const postTDI_data_Return = (response) => {
    var TDIList = response.data;
    
    return {
        type: actionTypes.POST_TDI_RETURN,
        data: TDIList
    }

}

export const clean_data= ()=>{
    
    return (dispatch) => {
        dispatch(post_data_NoReturn());
    }
}



const post_data_NoReturn = (error) => {
    return {
        type: actionTypes.POST_NO_RETURN,
        data: error
    }

}

//LOAD
export const get_single_object = (sessionId,id,endPoint) =>{
    // TODO : STORE OBJECT IN LOCALSTORAGE in CASE of RESET of the website 
    var tO = {...transfertObject};
    tO.ObjParamsDto = null;
    tO.ObjParamDto = ObjParamDto;
    tO.ObjParamDto.ARCS = id;
    tO.ObjParamDto.SessionIDE = localStorage.getItem('Reassurance.session.token');

    var transfertObjectTMP = {};
    transfertObjectTMP.ObjParamDto = tO.ObjParamDto;
    transfertObjectTMP.ObjDataDto = null;
    transfertObjectTMP.Session = tO.Session;
    

    return (dispatch) => {
        dispatch(clean_loaded_object());
        dispatch(startLoading());
        axios.ArcsAxios.post("/WCFWindowsArcs/"+endPoint+"Load", transfertObjectTMP)
            .then(response => {
                dispatch(get_object_Return(response));
                dispatch(stopLoading());
            })
            .catch(error => {
                
                dispatch(moduleActions.addModuleData("NOTIFICATION",
                    {
                        type:"exclamation-triangle",
                        title:"Endpoint communication error",
                        description : error.message +" using endpoint: "+endPoint
                    })
                );
                dispatch(post_data_NoReturn(error));
                dispatch(stopLoading());
            })
    }
}
const get_object_Return = (response)=>{
    return {
        type: actionTypes.GET_OBJECT_RETURN,
        data: response.data
    }
}
export const clean_loaded_object = ()=>{
    return {
        type: actionTypes.CLEAN_LOADED_OBJECT,
        data: null
    }
}

//SAVE
export const save_single_object = (sessionId,id,node,objDataDto,page) =>{
    // TODO : STORE OBJECT IN LOCALSTORAGE in CASE of RESET of the website 
    var tO = {...transfertObject};
    tO.ObjParamsDto = null;
    tO.ObjParamDto = ObjParamDto;
    tO.ObjParamDto.ARCS = id;
    tO.ObjParamDto.SessionIDE = localStorage.getItem('Reassurance.session.token');

    var transfertObjectTMP = {};
    transfertObjectTMP.ObjParamDto = tO.ObjParamDto;
    transfertObjectTMP.ObjDataDto = objDataDto;
    transfertObjectTMP.ObjDataDto.SessionIDE = localStorage.getItem('Reassurance.session.token');
    transfertObjectTMP.Session = tO.Session;
    

    return (dispatch) => {
        dispatch(startLoading());
        axios.ArcsAxios.post("/WCFWindowsArcs/"+node.endpoint+"Save", transfertObjectTMP)
            .then(response => {
                dispatch(save_object_Return(response));
                dispatch(stopLoading());
                //reload list
                dispatch(get_list_object(sessionId,node.endpoint,node,page));
            })
            .catch(error => {
                
                dispatch(moduleActions.addModuleData("NOTIFICATION",
                    {
                        type:"exclamation-triangle",
                        title:"Endpoint communication error",
                        description : error.message +" using endpoint: "+node.endpoint
                    })
                );
                dispatch(post_data_NoReturn(error));
                dispatch(stopLoading());
            })
    }
}
export const save_single_object_withFileTransfert = (sessionId,id,node,objDataDto,file) =>{
    // TODO : STORE OBJECT IN LOCALSTORAGE in CASE of RESET of the website 
    var tO = {...transfertObject};
    tO.ObjParamsDto = null;
    tO.ObjParamDto = ObjParamDto;
    tO.ObjParamDto.ARCS = id;
    tO.ObjParamDto.SessionIDE = localStorage.getItem('Reassurance.session.token');

    // GET FILE AS BYTEARRAY
    var ba = new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            
            resolve(event.target.result);
        };

        reader.onerror = (err) => {
            
            reject(err);
        };

        reader.readAsDataURL(file);
    });
    
    
    var transfertObjectTMP = {};
    transfertObjectTMP.ObjParamDto = tO.ObjParamDto;
    transfertObjectTMP.ObjDataDto = objDataDto;
    transfertObjectTMP.Session = tO.Session;
    

    // return (dispatch) => {
    //     dispatch(startLoading());
    //     axios.ArcsAxios.post("/WCFWindowsArcs/"+node.endpoint+"Save", transfertObjectTMP)
    //         .then(response => {
    //             dispatch(save_object_Return(response));
    //             dispatch(stopLoading());
    //             //reload list
    //             dispatch(get_list_object(sessionId,node.endpoint,node));
    //         })
    //         .catch(error => {
        
    //             dispatch(moduleActions.addModuleData("NOTIFICATION",
    //                 {
    //                     type:"exclamation-triangle",
    //                     title:"Endpoint communication error",
    //                     description : error.message +" using endpoint: "+node.endpoint
    //                 })
    //             );
    //             dispatch(post_data_NoReturn(error));
    //             dispatch(stopLoading());
    //         })
    // }
}
const save_object_Return = (response)=>{
    return {
        type: actionTypes.SAVE_OBJECT_RETURN,
        data: response.data
    }
}

//CREATE
export const create_single_object = (sessionId,object) =>{
    var tO = {...transfertObject};
    tO.ObjParamsDto = null;
    tO.ObjParamDto = ObjParamDto;
    tO.ObjParamDto.ARCS = 0;
    tO.ObjParamDto.SessionIDE = localStorage.getItem('Reassurance.session.token');

    var transfertObjectTMP = {};
    transfertObjectTMP.ObjParamDto = tO.ObjParamDto;
    transfertObjectTMP.ObjDataDto = object;
    transfertObjectTMP.ObjDataDto.SessionIDE = localStorage.getItem('Reassurance.session.token');
    transfertObjectTMP.Session = tO.Session;
    

    return {
        type: actionTypes.GET_OBJECT_RETURN,
        data: object
    }
}


//ARCHIVE
export const delete_single_object = (sessionId,id,node,objDataDto,page) =>{
    // ETAT : 255
    // TODO : STORE OBJECT IN LOCALSTORAGE in CASE of RESET of the website 
    var tO = {...transfertObject};
    tO.ObjParamsDto = null;
    tO.ObjParamDto = ObjParamDto;
    tO.ObjParamDto.ARCS = id;
    tO.ObjParamDto.SessionIDE = localStorage.getItem('Reassurance.session.token');

    var transfertObjectTMP = {};
    transfertObjectTMP.ObjParamDto = tO.ObjParamDto;
    transfertObjectTMP.ObjDataDto = objDataDto;
    transfertObjectTMP.ObjParamDto.ETAT = 255;
    transfertObjectTMP.Session = tO.Session;
    

    return (dispatch) => {
        dispatch(startLoading());
        axios.ArcsAxios.post("/WCFWindowsArcs/"+node.endpoint+"GUIAccessFlag", transfertObjectTMP)
            .then(response => {
                dispatch(save_object_Return(response));
                dispatch(stopLoading());
                //reload list
                dispatch(get_list_object(sessionId,node.endpoint,node,page));
            })
            .catch(error => {
                
                dispatch(moduleActions.addModuleData("NOTIFICATION",
                    {
                        type:"exclamation-triangle",
                        title:"Endpoint communication error",
                        description : error.message +" using endpoint: "+node.endpoint
                    })
                );
                dispatch(post_data_NoReturn(error));
                dispatch(stopLoading());
            })
    }
}

//UNARCHIVE
export const unarchive_single_object = (sessionId,id,node,objDataDto,page) =>{
    // ETAT : 255
    // TODO : STORE OBJECT IN LOCALSTORAGE in CASE of RESET of the website 
    var tO = {...transfertObject};
    tO.ObjParamsDto = null;
    tO.ObjParamDto = ObjParamDto;
    tO.ObjParamDto.ARCS = id;
    tO.ObjParamDto.SessionIDE = localStorage.getItem('Reassurance.session.token');

    var transfertObjectTMP = {};
    transfertObjectTMP.ObjParamDto = tO.ObjParamDto;
    transfertObjectTMP.ObjDataDto = objDataDto;
    transfertObjectTMP.ObjParamDto.ETAT = 0;
    transfertObjectTMP.Session = tO.Session;

    return (dispatch) => {
        dispatch(startLoading());
        axios.ArcsAxios.post("/WCFWindowsArcs/"+node.endpoint+"GUIAccessFlag", transfertObjectTMP)
            .then(response => {
                dispatch(save_object_Return(response));
                dispatch(stopLoading());
                //reload list
                dispatch(get_list_object(sessionId,node.endpoint,node,page));
            })
            .catch(error => {
                dispatch(moduleActions.addModuleData("NOTIFICATION",
                    {
                        type:"exclamation-triangle",
                        title:"Endpoint communication error",
                        description : error.message +" using endpoint: "+node.endpoint
                    })
                );
                dispatch(post_data_NoReturn(error));
                dispatch(stopLoading());
            })
    }
}

export const releaseObject = () =>{
    // BEFORE ANY OTHER CALL RELEASE THE PREVIOUS OBJECT
    // FLAG : 0

}


// ECLOAD
export const get_TDI = (session) =>{
    
    var transfertObjectTMP = {...transfertObject};
    transfertObjectTMP.ObjParamsDto = ObjParamsDto;
    transfertObjectTMP.ObjParamsDto.SessionIDE = localStorage.getItem('Reassurance.session.sessionId');
    transfertObjectTMP.ObjParamsDto.bPageIsActive = false;
    transfertObjectTMP.Session.Session = session;
    return (dispatch) => {
        var success = false;
        var responseData = null;
        dispatch(startLoading());
        axios.ArcsAxios.post("/WCFWindowsArcs/TDIECLoad", transfertObjectTMP)
            .then(response => {
                
                
                success = true;
                responseData = response;
                
            })
            .catch(error => {
                dispatch(moduleActions.addModuleData("NOTIFICATION",
                    {
                        type:"exclamation-triangle",
                        title:"Endpoint communication error",
                        description : error.message +" using endpoint: TDI"
                    })
                );
                dispatch(disconnect());
                dispatch(post_data_NoReturn(error));
            }).finally(res=>{
                if(success){
                    dispatch(postTDI_data_Return(responseData));
                }
            })

        
    }

}

export const get_list_object = (sessionId,endPoint,node,getOptions,page,newPage) =>{
    var transfertObjectTMP = {...transfertObject};
    transfertObjectTMP.ObjParamsDto = ObjParamsDto;
    transfertObjectTMP.ObjParamsDto.bPageIsActive = true;
    transfertObjectTMP.ObjParamsDto.iPageNumber = newPage?0:page;
    
     //END PAGINATION
    transfertObjectTMP.ObjParamsDto.SessionIDE = localStorage.getItem('Reassurance.session.sessionId');
    transfertObjectTMP.ObjParamsDto.ARCS_TP_N3 = 0;
    if(node!== null && endPoint !== "TDI"){
        transfertObjectTMP.ObjParamsDto.ARCS_TP_N3 = node.ARCS_TP_N3;
    }
    if(endPoint === "PAYS"){
        transfertObjectTMP.ObjParamsDto.CONTINENT_ARCS = node.CONTINENT_ARCS === null?0:node.CONTINENT_ARCS;
        transfertObjectTMP.ObjParamsDto.ARCS_TP_N3 = 0;
    }

    return (dispatch) => {
        if(transfertObjectTMP.ObjParamsDto.ARCS_TP_N3 == -1){
            
            dispatch(stopLoading());
        }else{
            dispatch(startLoading());
            axios.ArcsAxios.post("/WCFWindowsArcs/"+endPoint+"ECLoad", transfertObjectTMP)
                .then(response => {
                    dispatch(stopLoading());
                    // CHECK RECORD NUMBER
                    if(response.data.length < ObjParamDto.iPageWeigth){
                        dispatch(cantLoadMore());
                    }
                    if(node !== null){
                        if(getOptions){
                            
                            dispatch(get_list_options_Return(response));
                        }else{
                            
                            dispatch(get_objects_Return(response,page));
                        }
                        
                    }
                })
                .catch(error => {
                    dispatch(moduleActions.addModuleData("NOTIFICATION",
                        {
                            type:"exclamation-triangle",
                            title:"Endpoint communication error",
                            description : error.message +" using endpoint: "+endPoint
                        })
                    );
                    dispatch(post_data_NoReturn(error));
                    dispatch(stopLoading());
                })
        }
        
    }

}

const get_objects_Return = (response,page) =>{
    
    var data = {list:response.data,page:page};
    return {
        type: actionTypes.GET_OBJECTS_RETURN,
        data: data
    }
}

const get_list_options_Return = (response) =>{
    var data = response.data;
    return {
        type: actionTypes.GET_LIST_OPTIONS_RETURN,
        data: data
    }
}

//FORM UPDATE
export const  onUpdateValue = (columnName,e,lang) =>{
    return {
        type: actionTypes.UPDATE_FROM_FORM,
        data: {columnName:columnName,value:e,language:lang}
    }
  }
export const onCloseForm = ()=>{
    return {
        type: actionTypes.CLOSE_FORM,
        data: null
    }
}
// FORM CREATE BLANK
export const onCreateBlank = (object)=>{
    return {
        type: actionTypes.GET_OBJECT_RETURN,
        data: object
    }
}

// PAGINATION
export const resetPagination =()=>{
    console.log("reset Pagination");
    return {
        type: actionTypes.RESET_PAGINATION,
        data: null
    }
}
export const loadMore=()=>{
    return (dispatch) => {
        dispatch(startLoading());
    }
    
}

export const cantLoadMore=()=>{
    return {
        type: actionTypes.NO_MORE_RECORD,
        data: null
    }
}



// MOCKING DATA
export const init_mock = (data)=>{
    return{
        type: actionTypes.INIT_MOCK,
        data: data
    }
}